module.exports = __webpack_public_path__ + "img/deltares_new.eff4c75e.svg";